// src/pages/Accounts/expenseRecognitionsThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getRecognitionWithDetailsApi,
  saveRecognitionApi,
  deleteRecognitionApi,
  approveExpenseRecognitionApi,  
} from "../../apiservice/accounts";

// fetch all recognitions (with details)
export const fetchRecognitions = createAsyncThunk(
  "expenseRecognitions/fetchRecognitions",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getRecognitionWithDetailsApi({ oneDate: null });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


// save recognition (create / update)
export const saveRecognition = createAsyncThunk(
  "expenseRecognitions/saveRecognition",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await saveRecognitionApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// delete recognition
export const deleteRecognition = createAsyncThunk(
  "expenseRecognitions/deleteRecognition",
  async (recog_id, { rejectWithValue }) => {
    try {
      const res = await deleteRecognitionApi({ recog_id });
      return { id: recog_id, msg: res.data.msg };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const approveExpenseRecognition = createAsyncThunk(
  "expenseRecognitions/approve",
  async (recog_id, { rejectWithValue }) => {
    try {
      const res = await approveExpenseRecognitionApi({ recog_id });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

